import { render, staticRenderFns } from "./menu-icon.vue?vue&type=template&id=43b19f1f&scoped=true"
import script from "./menu-icon.vue?vue&type=script&lang=js"
export * from "./menu-icon.vue?vue&type=script&lang=js"
import style0 from "./menu-icon.vue?vue&type=style&index=0&id=43b19f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b19f1f",
  null
  
)

export default component.exports